exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-templates-paper-tsx": () => import("./../../../src/templates/paper.tsx" /* webpackChunkName: "component---src-templates-paper-tsx" */),
  "component---src-templates-pianissimo-tsx": () => import("./../../../src/templates/pianissimo.tsx" /* webpackChunkName: "component---src-templates-pianissimo-tsx" */),
  "component---src-templates-project-tsx": () => import("./../../../src/templates/project.tsx" /* webpackChunkName: "component---src-templates-project-tsx" */)
}

